import { MainLayout } from "@/components/layout/MainLayout"
import { CasesList } from "@/components/cases/CasesList"
import { Button } from "@/components/ui/button"
import { PlusCircle } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useCases } from "@/hooks/useCases"

const Cases = () => {
	const { data: cases, isLoading, error } = useCases()
	const navigate = useNavigate()

	return (
		<MainLayout>
			<div className="mb-8 flex items-end justify-between">
				<div>
					<h1 className="text-3xl font-semibold text-foreground">Cases</h1>
					<p className="text-muted-foreground mt-1">
						Manage all your neurosurgery cases
					</p>
				</div>
				<Button onClick={() => navigate("/cases/new")}>
					<PlusCircle className="h-4 w-4 mr-2" />
					New Case
				</Button>
			</div>

			{isLoading ? (
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					{[...Array(6)].map((_, i) => (
						<div key={i} className="case-folder animate-pulse">
							<div className="h-6 bg-gray-200 rounded mb-3 w-2/3"></div>
							<div className="h-4 bg-gray-200 rounded w-1/3"></div>
						</div>
					))}
				</div>
			) : (
				<CasesList cases={cases} />
			)}
			{error && (
				<div className="text-center py-12">
					<h2 className="text-xl font-medium text-destructive">
						Error loading cases
					</h2>
				</div>
			)}
		</MainLayout>
	)
}

export default Cases
